import script from "./FormStartTicket.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormStartTicket.vue?vue&type=script&lang=ts&setup=true"

import "./FormStartTicket.vue?vue&type=style&index=0&id=ef8ebda2&lang=scss"

const __exports__ = script;

export default __exports__